import React from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { routes } from '../data/trips/routes';
import RouteMap from '../components/RouteMap';
import WhatsAppCTA from '../components/WhatsAppCTA';
import '../styles/RouteDetails.css';
// Import some icons from react-icons for visual interest
import { FaStar, FaClock, FaRoad, FaUsers, FaMountain } from 'react-icons/fa';

const TripRouteDetail = () => {
  const { routeId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const route = routes.find(r => r.id === routeId);

  if (!route) {
    return <div>Ruta no encontrada</div>;
  }

  const handleBack = () => {
    if (location.state?.from) {
      navigate(location.state.from);
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="route-details">
      <button 
        onClick={handleBack}
        className="back-button"
      >
        ← Volver
      </button>
      
      <h1>{route.name}</h1>
      <p>{route.description}</p>

      {/* WhatsApp CTA after description */}
      <WhatsAppCTA />
      
      {/* Mapa interactivo */}
      <RouteMap mapUrl={route.mapUrl} />

      {/* Info principal y destacados en dos columnas en desktop */}
      <div className="main-info-grid">
        {/* Destacados */}
        <div className="route-highlights card">
          <h2><FaStar style={{color:'#f5b301', marginRight:6}}/>Destacados</h2>
          <ul>
            {route.highlights.map((highlight, index) => (
              <li key={index}>{highlight}</li>
            ))}
          </ul>
        </div>
        {/* Información de la ruta */}
        <div className="route-info card">
          <h2>Información de la ruta</h2>
          <p><FaClock style={{marginRight:6}}/><strong>Duración:</strong> {route.days} días</p>
          <p><FaRoad style={{marginRight:6}}/><strong>Distancia total:</strong> {route.totalDistance} km</p>
          <p><FaMountain style={{marginRight:6}}/><strong>Dificultad:</strong> {route.difficulty}</p>
          <p><FaUsers style={{marginRight:6}}/><strong>Ideal para:</strong> {route.bestFor.join(', ')}</p>
        </div>
      </div>

      {/* Itinerario */}
      <div className="route-itinerary">
        <h2>Itinerario</h2>
        {route.itinerary.map((day, index) => (
          <div key={index} className="day-plan card">
            <h3>Día {day.day}: {day.title}</h3>
            <p>{day.description}</p>
            <div className="stops">
              <h4>Paradas principales</h4>
              <ul>
                {day.stops.map((stop, stopIndex) => (
                  <li key={stopIndex}>
                    <strong>{stop.name}</strong>
                    {stop.description && <p>{stop.description}</p>}
                  </li>
                ))}
              </ul>
            </div>
            {day.nearby && day.nearby.length > 0 && (
              <div className="nearby">
                <h4>Lugares cercanos</h4>
                <ul>
                  {day.nearby.map((place, placeIndex) => (
                    <li key={placeIndex}>{place.name}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* WhatsApp CTA after itinerary */}
      <WhatsAppCTA />
    </div>
  );
};

export default TripRouteDetail; 